import Dashboard from "pages/Dashboard/Dashboard"
import Login from "pages/Login"
import User from "pages/User/User"
import UserForm from "pages/User/UserForm"
import Setting from "pages/Setting/Setting"
import Brand from "pages/Brand/Brand"
import BrandForm from "pages/Brand/BrandForm"
import Product from "pages/Product/Product"
import ProductForm from "pages/Product/ProductForm"
import SalesStock from "pages/SalesStock/SalesStock"
import SalesStockForm from "pages/SalesStock/SalesStockForm"
import RentalStock from "pages/RentalStock/RentalStock"
import RentalStockForm from "pages/RentalStock/RentalStockForm"
import Category from "pages/Category/Category"
import CategoryForm from "pages/Category/CategoryForm"
import Customer from "pages/Customer/Customer"
import CustomerForm from "pages/Customer/CustomerForm"
import SalesOrder from "pages/Transaction/SalesOrder"
import RentalOrder from "pages/Transaction/RentalOrder"
import TransactionDetail from "pages/Transaction/TransactionDetail"
import Tax from "pages/Setting/Tax/Tax"
import TransactionRental from "pages/Transaction/TransactionRental"
import TransactionSales from "pages/Transaction/TransactionSales"
import ExpenseCategory from "pages/Setting/ExpenseCategory/ExpenseCategory"
import Expenses from "pages/Expenses/Expenses"
import ExpenseForm from "pages/Expenses/ExpenseForm"

const route = (path, Component) => ({
   path,
   element: <Component />,
})

export const routes = [
   route("/login", Login),
   route("/", Dashboard),
   route("/transaction-sales", TransactionSales),
   route("/transaction-rental", TransactionRental),
   route("/transaction-detail", TransactionDetail),
   route("/expenses", Expenses),
   route("/expenses/form", ExpenseForm),
   route("/sales-order", SalesOrder),
   route("/rental-order", RentalOrder),
   route("/brand", Brand),
   route("/brand/form", BrandForm),
   route("/category", Category),
   route("/category/form", CategoryForm),
   route("/customer", Customer),
   route("/customer/form", CustomerForm),
   route("/product", Product),
   route("/product/form", ProductForm),
   route("/sales-stock", SalesStock),
   route("/sales-stock/form", SalesStockForm),
   route("/rental-stock", RentalStock),
   route("/rental-stock/form", RentalStockForm),
   route("/setting", Setting),
   route("/setting/user", User),
   route("/setting/user/form", UserForm),
   route("/setting/tax", Tax),
   route("/setting/expense-category", ExpenseCategory),
]

export const ROLE_ADMIN = "admin"
export const ROLE_OWNER = "owner"